var map = {
	"./Marksview1Component/Marksview1Component.module": [
		"./src/app/Marksview1Component/Marksview1Component.module.ts",
		"Marksview1Component-Marksview1Component-module"
	],
	"./Marksview2Component/Marksview2Component.module": [
		"./src/app/Marksview2Component/Marksview2Component.module.ts",
		"Marksview2Component-Marksview2Component-module"
	],
	"./Marksview3Component/Marksview3Component.module": [
		"./src/app/Marksview3Component/Marksview3Component.module.ts",
		"Marksview3Component-Marksview3Component-module"
	],
	"./allstudents/allstudents.module": [
		"./src/app/allstudents/allstudents.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~allstudents-allstudents-module~classes-classes-module~classwork-classwork-module~custom-sms-~79687aed",
		"default~allstudents-allstudents-module~school-school-module",
		"allstudents-allstudents-module"
	],
	"./alumni/alumni.module": [
		"./src/app/alumni/alumni.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"alumni-alumni-module"
	],
	"./attendance/attendance.module": [
		"./src/app/attendance/attendance.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"attendance-attendance-module"
	],
	"./card/card.module": [
		"./src/app/card/card.module.ts",
		"card-card-module"
	],
	"./carpools/carpools.module": [
		"./src/app/carpools/carpools.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"carpools-carpools-module"
	],
	"./child/child.module": [
		"./src/app/child/child.module.ts",
		"default~child-child-module~fee-fee-module~school-school-module",
		"default~child-child-module~events-events-module~gallery-gallery-module",
		"child-child-module"
	],
	"./classes/classes.module": [
		"./src/app/classes/classes.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~allstudents-allstudents-module~classes-classes-module~classwork-classwork-module~custom-sms-~79687aed",
		"classes-classes-module"
	],
	"./classwork/classwork.module": [
		"./src/app/classwork/classwork.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~allstudents-allstudents-module~classes-classes-module~classwork-classwork-module~custom-sms-~79687aed",
		"default~classwork-classwork-module~events-events-module~gallery-gallery-module",
		"classwork-classwork-module"
	],
	"./custom-sms/custom-sms.module": [
		"./src/app/custom-sms/custom-sms.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~allstudents-allstudents-module~classes-classes-module~classwork-classwork-module~custom-sms-~79687aed",
		"custom-sms-custom-sms-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./design-certificate/design-certificate.module": [
		"./src/app/design-certificate/design-certificate.module.ts",
		"design-certificate-design-certificate-module"
	],
	"./design-template/design-template.module": [
		"./src/app/design-template/design-template.module.ts",
		"design-template-design-template-module"
	],
	"./designer/designer.module": [
		"./src/app/designer/designer.module.ts",
		"designer-designer-module"
	],
	"./events/events.module": [
		"./src/app/events/events.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~child-child-module~events-events-module~gallery-gallery-module",
		"default~classwork-classwork-module~events-events-module~gallery-gallery-module",
		"events-events-module"
	],
	"./excel-reports/excel-reports.module": [
		"./src/app/excel-reports/excel-reports.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"excel-reports-excel-reports-module"
	],
	"./expense/expense.module": [
		"./src/app/expense/expense.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~allstudents-allstudents-module~classes-classes-module~classwork-classwork-module~custom-sms-~79687aed",
		"expense-expense-module"
	],
	"./extra-details/extra-details.module": [
		"./src/app/extra-details/extra-details.module.ts",
		"extra-details-extra-details-module"
	],
	"./fee-define/fee-define.module": [
		"./src/app/fee-define/fee-define.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~allstudents-allstudents-module~classes-classes-module~classwork-classwork-module~custom-sms-~79687aed",
		"fee-define-fee-define-module"
	],
	"./fee/fee.module": [
		"./src/app/fee/fee.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~child-child-module~fee-fee-module~school-school-module",
		"fee-fee-module"
	],
	"./gallery/gallery.module": [
		"./src/app/gallery/gallery.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~child-child-module~events-events-module~gallery-gallery-module",
		"default~classwork-classwork-module~events-events-module~gallery-gallery-module",
		"gallery-gallery-module"
	],
	"./gatecam/gatecam.module": [
		"./src/app/gatecam/gatecam.module.ts",
		"gatecam-gatecam-module"
	],
	"./holidays/holidays.module": [
		"./src/app/holidays/holidays.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~holidays-holidays-module~toppers-toppers-module",
		"holidays-holidays-module"
	],
	"./homework/homework.module": [
		"./src/app/homework/homework.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~allstudents-allstudents-module~classes-classes-module~classwork-classwork-module~custom-sms-~79687aed",
		"homework-homework-module"
	],
	"./libraries/libraries.module": [
		"./src/app/libraries/libraries.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"libraries-libraries-module"
	],
	"./livestream/livestream.module": [
		"./src/app/livestream/livestream.module.ts",
		"livestream-livestream-module"
	],
	"./magazine/magazine.module": [
		"./src/app/magazine/magazine.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~magazine-magazine-module~school-school-module~teachers-teachers-module~toppers-toppers-modul~a88554d9",
		"magazine-magazine-module"
	],
	"./marks-assign/marks-assign.module": [
		"./src/app/marks-assign/marks-assign.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"marks-assign-marks-assign-module"
	],
	"./non-teaching/non-teaching.module": [
		"./src/app/non-teaching/non-teaching.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"non-teaching-non-teaching-module"
	],
	"./online-classes/online-classes.module": [
		"./src/app/online-classes/online-classes.module.ts",
		"online-classes-online-classes-module"
	],
	"./other-details/other-details.module": [
		"./src/app/other-details/other-details.module.ts",
		"other-details-other-details-module"
	],
	"./rank/rank.module": [
		"./src/app/rank/rank.module.ts",
		"rank-rank-module"
	],
	"./report-cards/report-cards.module": [
		"./src/app/report-cards/report-cards.module.ts",
		"report-cards-report-cards-module"
	],
	"./report/report.module": [
		"./src/app/report/report.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"report-report-module"
	],
	"./request/request.module": [
		"./src/app/request/request.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"request-request-module"
	],
	"./results/results.module": [
		"./src/app/results/results.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"results-results-module"
	],
	"./routines/routine.module": [
		"./src/app/routines/routine.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"routines-routine-module"
	],
	"./school/school.module": [
		"./src/app/school/school.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~magazine-magazine-module~school-school-module~teachers-teachers-module~toppers-toppers-modul~a88554d9",
		"default~child-child-module~fee-fee-module~school-school-module",
		"default~allstudents-allstudents-module~school-school-module",
		"school-school-module"
	],
	"./tabular/tabular.module": [
		"./src/app/tabular/tabular.module.ts",
		"tabular-tabular-module"
	],
	"./teachers/teachers.module": [
		"./src/app/teachers/teachers.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~magazine-magazine-module~school-school-module~teachers-teachers-module~toppers-toppers-modul~a88554d9",
		"teachers-teachers-module"
	],
	"./toppers/toppers.module": [
		"./src/app/toppers/toppers.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~magazine-magazine-module~school-school-module~teachers-teachers-module~toppers-toppers-modul~a88554d9",
		"default~holidays-holidays-module~toppers-toppers-module",
		"toppers-toppers-module"
	],
	"./uploadform/uploadform.module": [
		"./src/app/uploadform/uploadform.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~carpools-carpools-module~classes-classes~4ea9f0d5",
		"uploadform-uploadform-module"
	],
	"./user-rights/user-rights.module": [
		"./src/app/user-rights/user-rights.module.ts",
		"user-rights-user-rights-module"
	],
	"./visitors/visitors.module": [
		"./src/app/visitors/visitors.module.ts",
		"default~allstudents-allstudents-module~alumni-alumni-module~attendance-attendance-module~carpools-ca~3cbb963a",
		"default~allstudents-allstudents-module~carpools-carpools-module~classes-classes-module~classwork-cla~feb0213e",
		"default~magazine-magazine-module~school-school-module~teachers-teachers-module~toppers-toppers-modul~a88554d9",
		"visitors-visitors-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;